import { render, staticRenderFns } from "./CrewHistoryTab.vue?vue&type=template&id=f95448ee&scoped=true"
import script from "./CrewHistoryTab.vue?vue&type=script&lang=js"
export * from "./CrewHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./CrewHistoryTab.vue?vue&type=style&index=0&id=f95448ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95448ee",
  null
  
)

export default component.exports